import { render, staticRenderFns } from "./BackerCenterPaymentsPreview.vue?vue&type=template&id=bb633020"
import script from "./BackerCenterPaymentsPreview.vue?vue&type=script&lang=js"
export * from "./BackerCenterPaymentsPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports